export const fileChecksum = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const worker = new Worker(
      new URL("../workers/fileChecksum.worker.ts", import.meta.url),
      { type: "module" },
    );
    worker.onmessage = ({
      data,
    }: MessageEvent<{ digest?: string; error?: string }>) => {
      worker.terminate();
      if (data.digest) resolve(data.digest);
      else reject(new Error(data.error || "Unable to prepare this upload."));
    };
    worker.onerror = () => {
      worker.terminate();
      reject(new Error("Unable to prepare this upload. Please try again."));
    };
    worker.postMessage(file);
  });
